import { feedbackSearchSchema } from "./feedback-route.contract";
import { seoMeta } from "@/lib/ui/seo";

export const feedbackRoute = {
    validateSearch: feedbackSearchSchema,
    head: () =>
        seoMeta({
            title: "Feedback — Wags",
            description: "Tell us how we're doing.",
            url: "/feedback",
        }),
};
